"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestDepartment = void 0;
const tslib_1 = require("tslib");
const model_1 = require("../model");
const batch_1 = require("./batch");
const cache_1 = require("./cache");
const fetchable_1 = require("./fetchable");
const collection_object_1 = require("./objects/collection.object");
const form_object_1 = require("./objects/form.object");
const object_1 = require("./objects/object");
const query_1 = require("./query");
const rest_1 = require("./rest");
const rest_department_attachment_1 = require("./rest.department.attachment");
const rest_department_image_1 = require("./rest.department.image");
class IkeRestDepartment {
    constructor(boundUser, departmentId) {
        this.Objects = object_1.IkeRestObjects;
        this.Attachment = new rest_department_attachment_1.IkeRestDepartmentAttachment(this);
        this.Tag = {
            getById: (objectId) => this.getOne(this.Objects.Tag, 'uuid', objectId),
            getByName: this.bindAction('tag.get'),
            getOrCreate: this.bindAction('tag.create'),
            Summary: {
                getById: (objectId) => this.getOne(this.Objects.TagSummary, 'objectId', objectId),
            },
        };
        this.Event = {
            create: this.bindAction('event.create'),
        };
        this.Calibration = {
            getById: (objectId) => this.getOne(this.Objects.Calibration, 'objectId', objectId),
            create: this.bindAction('calibration.create'),
        };
        this.Capture = {
            getById: (objectId) => this.getOne(this.Objects.Capture, 'objectId', objectId),
            getByUuid: (uuid) => this.getOne(this.Objects.Capture, 'uuid', uuid),
            Image: new rest_department_image_1.IkeRestDepartmentImage(this),
            data: this.bindAction('capture.data'),
            create: this.bindAction('capture.create'),
            getMask: this.bindAction('collection.capture.mask.get'),
        };
        this.AnnotationSummary = {
            getByUuid: (uuid) => this.getOne(this.Objects.AnnotationSummary, 'uuid', uuid),
            getById: (objectId) => this.getOne(this.Objects.AnnotationSummary, 'collectionId', objectId),
            getByRevision: (revision) => this.getOne(this.Objects.AnnotationSummary, 'revision', revision),
            create: this.bindAction('annotation.summary.create'),
        };
        this.CollectionSummary = {
            getByUuid: (uuid) => this.getOne(this.Objects.CollectionSummary, 'uuid', uuid),
            getById: (objectId) => this.getOne(this.Objects.CollectionSummary, 'collectionId', objectId),
            getByRevision: (revision) => this.getOne(this.Objects.CollectionSummary, 'revision', revision),
            create: this.bindAction('collection.summary.create'),
        };
        this.Collection = {
            getById: (objectId) => this.getOne(this.Objects.Collection, 'objectId', objectId),
            getByUuid: (uuid) => this.getOne(this.Objects.Collection, 'uuid', uuid),
            getByRevision: (revision) => this.getOne(this.Objects.Collection, 'revision', revision),
            getModel: (revision) => this.getModel(revision),
            assign: this.bindAction('collection.assign'),
            Import: {
                csv: this.bindAction('collection.import.csv'),
                excel: this.bindAction('collection.import.excel'),
            },
            exportImportableExcelTemplate: this.bindAction('export.importable.excel.template'),
            delete: this.bindAction('collection.delete'),
            duplicate: this.bindAction('collection.duplicate'),
            moveToJob: this.bindAction('collection.move.to.job'),
            moveToDepartment: this.bindAction('collection.move.to.department'),
            create: this.bindAction('collection.create'),
            search: this.bindAction('collection.search'),
            repair: this.bindAction('collection.repair'),
            revert: this.bindAction('collection.revert'),
            insightProcess: this.bindAction('department.insight.process'),
            migrate: this.bindAction('collection.migrate'),
        };
        this.Department = {
            getById: this.bindAction('department.get.departmentid'),
            User: {
                getProfileById: (objectId) => this.getOne(this.Objects.UserProfile, 'objectId', objectId),
                role: this.bindAction('department.user.role'),
                list: this.bindAction('department.user.list'),
                profile: this.bindAction('user.profile'),
                isLicensed: this.bindAction('user.is.licensed'),
            },
            Invite: {
                do: this.bindAction('department.invite'),
            },
        };
        this.Task = {
            create: this.bindAction('task.create'),
            status: this.bindAction('task.status'),
        };
        this.Form = {
            getById: (id) => this.getOne(this.Objects.Form, 'objectId', id),
            getByRevision: (revision) => this.getOne(this.Objects.Form, 'version', revision),
            getModel: (revision) => this.form('version', revision),
            delete: this.bindAction('form.delete'),
            restore: this.bindAction('form.restore'),
            share: this.bindAction('form.share'),
            copy: this.bindAction('form.copy'),
            Pla: {
                getRefreshPermission: this.bindAction('refresh.form.ipf.license.check'),
                metadata: this.bindAction('form.pla.metadata'),
                import: this.bindAction('form.pla.import'),
                importPoleforeman: this.bindAction('form.pla.import.poleforeman'),
                savePoleForemanDb: this.bindAction('form.pla.import.save.poleforeman'),
            },
            Summary: {
                list: this.bindAction('form.summary'),
                getByRevision: (revision) => this.getOne(this.Objects.FormSummary, 'revision', revision),
            },
        };
        this.boundUser = boundUser;
        this.departmentId = departmentId;
        this.log = boundUser.log.child({ departmentId });
        this.tokens = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), () => this.query(object_1.IkeRestObjects.Token).find());
        this.tags = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), () => this.query(object_1.IkeRestObjects.Tag).findAll());
        this.formSummaries = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.action('form.summary');
            return response.results;
        }));
        this.empty = new fetchable_1.IkeFetchableOne(this.log, rest_1.IkeRest.createStore(), () => Promise.resolve(null));
        this.cache = new cache_1.IkeRestCacheControl();
        this.batcher = new batch_1.IkeRestBatchControl(this);
    }
    form(key, value) {
        let existing = this.cache.get(form_object_1.IkeObjectFormModel, key).get(key, value);
        if (existing == null) {
            existing = new fetchable_1.IkeFetchableTransform(this.log, rest_1.IkeRest.createStore(), this.getOne(object_1.IkeRestObjects.Form, key, value), (formJSON) => tslib_1.__awaiter(this, void 0, void 0, function* () { return model_1.IkeModel.Form.read(formJSON); }));
            this.cache.get(form_object_1.IkeObjectFormModel, key).set(key, value, existing);
        }
        return existing;
    }
    getModel(revision) {
        const existing = this.cache.get(collection_object_1.IkeObjectCollectionModel, 'revision').get('revision', revision);
        if (existing != null) {
            return existing;
        }
        const fetchable = new fetchable_1.IkeFetchableTransform(this.log, rest_1.IkeRest.createStore(), this.getOne(object_1.IkeRestObjects.Collection, 'revision', revision), (c) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (c == null) {
                let cs = yield this.CollectionSummary.getByRevision(revision).fetch();
                if (cs == null) {
                    throw new Error(`Unable to fetch collection model with revision: ${revision}`);
                }
                const repaired = yield this.CollectionSummary.create({ uuid: cs.uuid, repair: true });
                if (repaired) {
                    c = yield this.getOne(object_1.IkeRestObjects.Collection, 'uuid', cs.uuid).fetch();
                    if (c == null) {
                        throw new Error(`Unable to fetch collection model with uuid: ${cs.uuid}`);
                    }
                }
                else {
                    throw new Error(`Unable to repair collection model with revision: ${revision}`);
                }
            }
            const formModel = yield this.form('version', c.formversion).fetch();
            const model = model_1.IkeModel.Collection.read(c, formModel, this, this.log);
            // Revision may change if collection was repaired
            this.cache.get(collection_object_1.IkeObjectCollectionModel, 'revision').set('revision', model.revision, fetchable);
            // TODO if we ever want a model to reference another collection model
            // We cannot wait for it to be ready here.
            yield model.ready();
            return model;
        }));
        this.cache.get(collection_object_1.IkeObjectCollectionModel, 'revision').set('revision', revision, fetchable);
        return fetchable;
    }
    action(path, data) {
        return this.boundUser.core._post(path, data, this.boundUser.accessToken, this.departmentId);
    }
    actionRaw(path, data) {
        return this.boundUser.core._raw(path, data, this.boundUser.accessToken, this.departmentId);
    }
    query(obj) {
        return new query_1.IkeRestQuery(this.boundUser.core, obj, this.boundUser.accessToken, this.departmentId, this.log);
    }
    save(obj, value, modifications, silent) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.action(`${obj.actionName}.save`, Object.assign(Object.assign({ value }, (modifications && { modifications })), { silent }));
            return response.results;
        });
    }
    /**
     * Get data from the API, generally should be called via the helper functions
     *  @see IkeDepartmentRest.Collection.getByRevision
     */
    getOne(obj, key, value) {
        let existing = this.cache.get(obj, key).get(key, value);
        if (existing == null) {
            const requestObj = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const result = yield this.batcher.batch(obj, key, value);
                if (obj.updateCache != null) {
                    obj.updateCache(key, result, this);
                }
                return result;
            });
            existing = new fetchable_1.IkeFetchableOne(this.log, rest_1.IkeRest.createStore(), requestObj);
            this.cache.get(obj, key).set(key, value, existing);
        }
        return existing;
    }
    /** Create a helper function to run a action */
    bindAction(path) {
        return (data) => this.boundUser.core._post(path, data, this.boundUser.accessToken, this.departmentId);
    }
    updateBoundUser(newBoundUser) {
        this.boundUser = newBoundUser;
    }
}
exports.IkeRestDepartment = IkeRestDepartment;
//# sourceMappingURL=rest.department.js.map